import appConfig from 'helper/mapBackendConfig';
import noop from 'helper/noop';
import { WindowType } from 'types/Window';

const win = (window as any) as WindowType;

/*
 * Disabling React DevTools if no extension available or devtools disabled
 * @see https://github.com/facebook/react-devtools/issues/191
 */
if (!appConfig.env.devToolsEnabled && win.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
	win.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = noop;
}
